// sso_host 线上：https://ssosv.sankuai.com/sson  线下：http://ssosv.it.test.sankuai.com/sson

import { getOrigin } from './tool';
import SSOConfig from './SSOConfig';

const sso_host = `${SSOConfig.SSOHost}/sson`;
const { clientId } = SSOConfig || {};
const sso_callback_url = `${window.location.origin || getOrigin()}${SSOConfig.SSOCallbackUrl}`;


export const getSSOLoginUrl = () => {
  // 登录域名
  const loginOrigin = `${sso_host}/login`;
  const { href } = window.location;
  let { origin } = window.location;
  // sso还有一些老设备,兼容一下ie
  if (!origin) {
    origin = getOrigin();
  }

  const currentPath = href.replace(new RegExp(`^${origin}`), '');

  // 例：https://ssosv.sankuai.com/sson/login?client_id=com.iph.zhaopin&redirect_uri=http%3A%2F%2Fzhaopin.sankuai.com%2Fsso%2Fcallback%3Foriginal-url%3D%252F
  return `${loginOrigin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(
    `${sso_callback_url}?original-url=${encodeURIComponent(currentPath)}`
  )}`;
};
